import { createStore, applyMiddleware } from 'redux'
import reduxThunk from 'redux-thunk'
import reducers from '../reducers'

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore)
export default createStoreWithMiddleware(reducers)


// WEBPACK FOOTER //
// ./src/utils/store.js